import { cannot } from '@/app/helpers'
import type { Condition } from '@/app/types'

export const validateConditionValue = (condition: Condition): string | undefined => {
  const [operator] = condition

  switch (operator) {
    case 'notStartsWith':
      return String(condition[2] ?? '').trim().length > 0 ? undefined : 'This field is required.'
    case 'and':
    case 'or':
    case '==':
    case 'equal':
    case '!=':
    case 'not_equal':
    case '>':
    case '<':
    case '>=':
    case '<=':
    case 'in':
    case 'notIn':
    case 'contain':
    case 'not_contain':
    case 'regex':
    case 'notRegex':
    case 'empty':
    case 'not_empty':
    case 'startsWith':
    case 'anyStartsWith':
    case 'noneStartsWith':
    case 'before':
    case 'after':
    case 'mod2_equal':
    case 'mod3_equal':
    case 'mod4_equal':
    case 'mod5_equal':
    case '':
      return undefined
    default:
      return cannot(operator)
  }
}
